/**
 * Routes where the user is entering data (forms, wizards).
 * The sidebar is hidden on these paths to maximize workspace.
 *
 * The `new|edit` rule covers every create/edit form. The rest are wizards and
 * multi-step flows that don't follow that naming. Each is `$`-anchored so a sibling
 * detail page keeps its sidebar — `/stock/consolidations` is a form, but
 * `/stock/consolidations/:id` is a read-only detail page.
 */
const FOCUS_PATTERNS = [
  /\/(new|edit)(\/|$)/,
  /\/start-dispense\/[^/]+$/,
  /\/direct-dispenses\/dispense$/,
  /\/direct-dispenses\/(quick-register|walk-in|direct)$/,
  /\/requisitions\/[^/]+\/issue$/,
  /\/rejected-items\/replacement-grn\/[^/]+$/,
  /\/stock\/consolidations$/,
];

export function isFocusRoute(pathname) {
  if (!pathname) return false;
  const clean = pathname.replace(/\/+$/, '') || '/';
  return FOCUS_PATTERNS.some((re) => re.test(clean));
}
